function validateEmptyDekaz(inputgroup, placeholder, placeholdererror,keyup){
    const input = inputgroup.querySelector('input')
    const label = inputgroup.querySelector('label')
    if(!keyup){
        
        if(input.value.length === 0){
            label.innerText = placeholdererror;
            inputgroup.classList.add('invalid');
            inputgroup.classList.remove('valid');
            return false
        } else {
            label.innerText = placeholder;
            inputgroup.classList.remove('invalid');
            inputgroup.classList.add('valid');
            return true
        }
    } else {
        if(input){
        input.addEventListener('keyup', function() {
            if(input.value.length == 0)
            {
            label.innerHtml = placeholdererror;
            inputgroup.classList.add('invalid');
            
            } else {
                label.innerHtml = placeholder;
                inputgroup.classList.remove('invalid');
            }
            // console.log('keyup: %s', this.value);
          });
        }    
    }
    
}

export default validateEmptyDekaz

